// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25Usc","productName":"Table_productName__1umzY"};